import { render, staticRenderFns } from "./LinkDepartments.vue?vue&type=template&id=b3d7e4ac&scoped=true&lang=pug&"
import script from "./LinkDepartments.vue?vue&type=script&lang=js&"
export * from "./LinkDepartments.vue?vue&type=script&lang=js&"
import style0 from "./LinkDepartments.vue?vue&type=style&index=0&id=b3d7e4ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d7e4ac",
  null
  
)

export default component.exports